/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { InfoPopover } from '@/components/ui/info';
import { ArbeitstageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/ArbeitstageSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
  Separator,
  Toggle,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function AbwesenheitenAllgemein() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col md:gap-10 gap-6">
      <div className="flex flex-col gap-4">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7 flex items-center gap-1">
          {ctx.getCurrentSubStep()?.title}
          <InfoPopover
            text={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.info',
            )}
          />
        </h2>
        <div className="grid md:grid-cols-2">
          <form.AppField name="abwesenheiten.allgemein.anzahlUrlaubstage">
            {(field) => (
              <FieldBase
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.label',
                )}
                isRequired>
                <InputGroup>
                  <InputGroupInput
                    value={field.state.value}
                    onChange={(e) => field.handleChange(e.target.value)}
                    onBlur={field.handleBlur}
                  />
                  <InputGroupAddon align="inline-end">
                    <InputGroupText className="text-neutrals-700">
                      {t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.suffix',
                      )}
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FieldBase>
            )}
          </form.AppField>
        </div>
      </div>
      <Separator />
      <div className="flex flex-col gap-4">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7">
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.title',
          )}
        </h2>
        <ArbeitstageSelect />
      </div>
      <Separator />
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <h2 className="text-neutrals-900 text-xl font-bold leading-7">
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.title',
            )}
          </h2>
          <span className="text-neutrals-800 text-sm font-normal leading-5">
            {t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.description',
            )}
          </span>
        </div>
        <form.AppField
          name="abwesenheiten.allgemein.stundenBewertung"
          listeners={{
            onChange: (val) => {
              if (val.value === 'dynamisch') {
                form.resetField('abwesenheiten.allgemein.stunden');
              }
            },
          }}>
          {(field) => (
            <FieldBase>
              <div className="grid md:grid-cols-2 gap-4">
                <Toggle
                  value="fest"
                  onPressedChange={() => field.handleChange('fest')}
                  pressed={field.state.value === 'fest'}
                  variant={'outline'}
                  className="flex items-center justify-start gap-2 p-4 h-auto">
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.options.fest',
                  )}
                </Toggle>
                <Toggle
                  value="dynamisch"
                  onPressedChange={() => field.handleChange('dynamisch')}
                  pressed={field.state.value === 'dynamisch'}
                  variant={'outline'}
                  className="flex items-center justify-start gap-2 p-4 h-auto">
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.options.dynamisch',
                  )}
                </Toggle>
              </div>
            </FieldBase>
          )}
        </form.AppField>
        <form.Subscribe
          selector={(state) => ({
            stundenbewertung:
              state.values.abwesenheiten.allgemein.stundenBewertung,
          })}>
          {({ stundenbewertung }) =>
            stundenbewertung === 'fest' && (
              <div className="grid md:grid-cols-2">
                <form.AppField name="abwesenheiten.allgemein.stunden">
                  {(field) => (
                    <field.HoursInput
                      label={t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
                      )}
                      isRequired
                      maxHours={24}
                      placeholder="hh:mm"
                      suffix={t(
                        'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.suffix',
                      )}
                    />
                  )}
                </form.AppField>
              </div>
            )
          }
        </form.Subscribe>
      </div>
    </div>
  );
}
